<template>
  <div>
    <b-container class="main-container">
      <b-row>
        <b-col sm="9">
          <widget heading="Student Information">
            <student-information :student="studentOpportunity.student"
              v-if="studentOpportunity.student"></student-information>
          </widget>

          <widget :heading="(studentOpportunity.opportunity.translationalTeam
            ? studentOpportunity.opportunity.translationalTeam.name + ' @ '
            : '') +
            (studentOpportunity.opportunity.site
              ? studentOpportunity.opportunity.site.name
              : '') +
            (studentOpportunity.opportunity.name
              ? ' (' + studentOpportunity.opportunity.name + ')'
              : '')
            " v-if="studentOpportunity.opportunity &&
    (isOpportunitiesViewer || isOpportunitiesManager)
    ">
            <opportunity-information :opportunity="studentOpportunity.opportunity"
              v-if="studentOpportunity.opportunity"></opportunity-information>
          </widget>

          <widget heading="Contracts" v-if="isContractViewer || isContractManager">
            <site-contracts :contracts="contracts"></site-contracts>
          </widget>

          <h3>Additional Materials</h3>

          <b-alert style="font-weight: bold" variant="info" dismissible fade show>
            Please note:
            <ul>
              <li>
                You must click 'Set Status' to save the selected status for this
                opportunity.
              </li>
              <li>
                An opportunity can be approved only after ALL of its additional
                materials have been approved.
              </li>
            </ul>
          </b-alert>

          <!-- {{studentOpportunity}} -->
          <b-alert :show="showDeadlineAlert" variant="danger" style="font-weight: bold">
            Opportunities should not be approved 21 days after the start of the
            semester
          </b-alert>

          <div v-if="studentOpportunity.studentOpportunityAdditionalMaterials">
            <div v-for="studentOpportunityAdditionalMaterial in studentOpportunity.studentOpportunityAdditionalMaterials"
              :key="studentOpportunityAdditionalMaterial.studentOpportunityAdditionalMaterialId
                ">
              <widget :heading="studentOpportunityAdditionalMaterial.additionalMaterialType
                .name +
                ' (' +
                (studentOpportunityAdditionalMaterial.additionalMaterialType
                  .required
                  ? 'Required'
                  : 'Optional') +
                ')'
                ">
                <additional-material :studentOpportunityAdditionalMaterial="studentOpportunityAdditionalMaterial
                  " :studentOpportunity="studentOpportunity" :additionalMaterialStatuses="additionalMaterialStatuses"
                  @refresh="getStudentOpportunity" :editable="isStudentPlacementsManager"></additional-material>
              </widget>
            </div>
          </div>

          <widget heading="Notes">
            <student-notes :notes="notes" :asuriteId="studentOpportunity.asuriteId"
              :studentOpportunityId="studentOpportunity.studentOpportunityId"></student-notes>
          </widget>
        </b-col>
        <b-col sm="3">
          <!-- <div class="card p-sm-2 side-card">
            <dl class="row">
                <dt class="col-sm-6">Stage: </dt>
                <dd class="col-sm-6" v-if="studentOpportunity.studentOpportunityStage">{{studentOpportunity.studentOpportunityStage.name}}</dd>
                <dt class="col-sm-6">Status: </dt>
                <dd class="col-sm-6" v-if="studentOpportunity.studentOpportunityStatus">{{studentOpportunity.studentOpportunityStatus.name}}</dd>
                <dt class="col-sm-6">Type: </dt>
                <dd class="col-sm-6" v-if="studentOpportunity.studentOpportunityType">{{studentOpportunity.studentOpportunityType.name}}</dd>
            </dl>
          </div> -->

          <!-- <div
            class="card p-sm-2 side-card"
            v-if="studentOpportunity.opportunity"
          > -->
          <div class="card p-sm-2 side-card" v-if="studentOpportunity.opportunity">

            <map-display :streetAddress="studentOpportunity.opportunity.site.streetAddress"
              :city="studentOpportunity.opportunity.site.city" :state="studentOpportunity.opportunity.site.state"
              :zip="studentOpportunity.opportunity.site.zip"
              v-if="studentOpportunity.opportunity.site.streetAddress || studentOpportunity.opportunity.site.zip || studentOpportunity.opportunity.site.city || studentOpportunity.opportunity.site.state"></map-display>

          </div>

          <div class="card p-sm-2 side-card">
            <h5>Dates and Hours</h5>
            <div class="row">
              <dl>
                <dt class="col-sm-12">Start Date</dt>
                <dd class="col-sm-12">
                  {{
                    studentOpportunity.startDate
                    ? studentOpportunity.startDate
                    : "" | formatDate
                  }}
                </dd>
                <dt class="col-sm-12">End Date</dt>
                <dd class="col-sm-12">
                  {{
                    studentOpportunity.endDate
                    ? studentOpportunity.endDate
                    : "" | formatDate
                  }}
                </dd>
                <dt class="col-sm-12">Hours Worked</dt>
                <dd class="col-sm-12">
                  {{
                    studentOpportunity.hoursWorked
                    ? studentOpportunity.hoursWorked
                    : ""
                  }}
                </dd>
              </dl>
            </div>
            <b-button variant="primary" v-b-modal.hours-modal>Update</b-button>
          </div>

          <div class="card p-sm-2 side-card">
            <h5>Selected Class</h5>
            <div v-if="studentOpportunity.scheduleLineNumber">
              <div>
                {{ studentOpportunity.subjectCode | notAvailable }}
                {{ studentOpportunity.catalogNumber | notAvailable }} ( SLN:
                {{ studentOpportunity.scheduleLineNumber | notAvailable }} )
              </div>
              <div>
                {{ studentOpportunity.sessionLd | notAvailable }} |
                {{ studentOpportunity.locationCode | notAvailable }} |
                {{ studentOpportunity.instructionMode | notAvailable }}
              </div>
              <b-alert variant="info" :show="hasSelectedCourse">This student is enrolled in the class.</b-alert>
              <b-alert variant="warning" :show="!hasSelectedCourse && hasInternshipCourse">This student is not enrolled in
                the selected class but is
                enrolled in one of the selected opportunity classes.</b-alert>
              <b-alert variant="warning" :show="!hasSelectedCourse && !hasInternshipCourse">This student is not enrolled
                in any related class.</b-alert>
            </div>
            <div v-else>
              <div>None selected</div>
              <b-alert variant="info" :show="hasInternshipCourse">This student is enrolled in one of the selected
                opportunity
                classes.</b-alert>
              <b-alert variant="warning" :show="!hasInternshipCourse">This student is not enrolled in any related
                class.</b-alert>
            </div>
            <b-button variant="primary" v-b-modal.course-modal>Change Enrolled Course</b-button>
          </div>

          <!-- <div class="card p-sm-2 side-card">
            <h5>Placement Contacts</h5>
            <site-contacts :contacts="studentOpportunity.opportunity.site.siteContacts"
                           v-if="studentOpportunity.opportunity"
                           opportunity></site-contacts>
          </div> -->

          <div class="card p-sm-2 side-card">
            <h5>Site Supervisor(s)</h5>
            <site-contacts :contacts="[contact]" opportunity v-if="contact"></site-contacts>
            <b-button variant="primary" v-b-modal.contact-modal>Change Site Supervisor</b-button>
          </div>
        </b-col>
      </b-row>

      <b-modal id="contact-modal" title="Change Site Supervisor" v-model="show" hide-footer>
        <contact-form @submitted="updateStudentOpportunityContact" @cancel="show = false" v-model="contact" v-if="show"
          :supervisors="studentOpportunity.opportunity.site.siteContacts"></contact-form>
      </b-modal>

      <b-modal id="course-modal" title="Change Enrolled Course" v-model="showCourseModal" hide-footer>
        <course-form @submitted="updateStudentCourse" @cancel="showCourseModal = false" v-model="course"
          :termCode="studentOpportunity.opportunity.term.termCode"
          :studentOpportunityId="studentOpportunity.studentOpportunityId" :subjectCode="studentOpportunity.subjectCode"
          :catalogNumber="studentOpportunity.catalogNumber" :scheduleLineNumber="studentOpportunity.scheduleLineNumber"
          v-if="showCourseModal"></course-form>
      </b-modal>

      <b-modal id="hours-modal" title="Update Dates and Hours" v-model="showHoursModal" hide-footer>
        <dates-form @submitted="updateDates" @cancel="showHoursModal = false" v-model="course"
          :studentOpportunity="studentOpportunity" v-if="showHoursModal" />
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import StudentInformation from "../../components/students/student-information";
import OpportunityInformation from "../../components/students/opportunity-information";
import AdditionalMaterial from "../../components/students/additional-material";
import StudentNotes from "../../components/students/student-notes";
import SiteContacts from "../../components/sites/site-contacts";
import Widget from "../../components/widget";
import MapDisplay from "../../components/map-display";
import studentOpportunityApi from "../../api/studentOpportunity";
import SiteContracts from "../../components/sites/site-contracts";
import roleChecks from "../../misc/role-checks";
import ContactForm from "../../components/sites/contact-form";
import CourseForm from "../../components/students/course-form";
import DatesForm from "../../components/students/dates-form";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import student from "../../api/student";

export default {
  mixins: [roleChecks],
  data() {
    return {
      studentOpportunity: {},
      additionalMaterialStatuses: [],
      notes: [],
      show: false,
      showCourseModal: false,
      showHoursModal: false,
      course: {}
    };
  },

  props: {
    studentOpportunityId: {
      required: true
    }
  },

  components: {
    "student-information": StudentInformation,
    "opportunity-information": OpportunityInformation,
    "additional-material": AdditionalMaterial,
    "student-notes": StudentNotes,
    "site-contacts": SiteContacts,
    widget: Widget,
    "map-display": MapDisplay,
    "site-contracts": SiteContracts,
    "contact-form": ContactForm,
    CourseForm,
    DatesForm
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    showDeadlineAlert: function () {
      return (
        this.studentOpportunity.opportunityType &&
        (this.studentOpportunity.opportunityType.name == "Internship" ||
          (this.studentOpportunity.opportunityType.name ==
            "Translational Team" &&
            (this.studentOpportunity.opportunityCategory.name == "Credit" ||
              this.studentOpportunity.opportunityCategory.name ==
              "Paid Credit")))
      );
    },

    hasSelectedCourse: function () {
      if (!this.studentOpportunity.studentView) {
        return false;
      }

      const subjectCode = this.studentOpportunity.subjectCode;
      const catalogNumber = this.studentOpportunity.catalogNumber;
      const scheduleLineNumber = this.studentOpportunity.scheduleLineNumber;
      return (
        _.filter(this.studentOpportunity.studentView.studentCourses, course => {
          return (
            course.subjectCode === subjectCode.trim() &&
            course.catalogNumber === catalogNumber.trim() &&
            course.classNumber === scheduleLineNumber
          );
        }).length > 0
      );
    },

    hasInternshipCourse: function () {
      if (!this.studentOpportunity.studentView) {
        return false;
      }
      return (
        _.filter(this.studentOpportunity.studentView.studentCourses, course => {
          return (
            _.filter(
              this.studentOpportunity.opportunity.opportunityInternshipCourses,
              oic => {
                return (
                  course.subjectCode === oic.internshipCourse.subjectCode &&
                  course.catalogNumber ===
                  oic.internshipCourse.catalogNumber.toString()
                );
              }
            ).length > 0
          );
        }).length > 0
      );
    },

    contracts: function () {
      if (this.studentOpportunity.opportunity) {
        return _.map(
          this.studentOpportunity.opportunity.site.contractSites,
          function (contractSite) {
            return contractSite.contract;
          }
        );
      }
      return [];
    },

    contact: function () {
      var contacts = _.map(
        this.studentOpportunity.studentOpportunityContacts,
        function (studentOpportunityContact) {
          return studentOpportunityContact.siteContact;
        }
      );
      if (contacts.length) {
        return contacts[0];
      }
    },

    hasAddress: function () {
      return (
        this.studentOpportunity &&
        (this.studentOpportunity.opportunity.site.streetAddress ||
          this.studentOpportunity.opportunity.site.city ||
          this.studentOpportunity.opportunity.site.state ||
          this.studentOpportunity.opportunity.site.zip)
      );
    }
  },

  methods: {
    ...mapActions("sites", ["getSiteSupervisorsByStudentOpportunity"]),
    getStudentOpportunity: function () {
      var that = this;
      studentOpportunityApi
        .getStudentOpportunityById(this.studentOpportunityId)
        .then(function (response) {
          that.studentOpportunity = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    updateStudentOpportunityContact: function (studentOpportunityContact) {
      this.$set(this.studentOpportunity.studentOpportunityContacts, 0, {
        studentOpportunityId: this.studentOpportunityId,
        siteContactId: studentOpportunityContact.siteContactId,
        siteContact: studentOpportunityContact
      });

      var siteContactId = studentOpportunityContact.siteContactId
        ? studentOpportunityContact.siteContactId
        : 0;
      studentOpportunityContact.siteContactId = siteContactId;

      studentOpportunityApi
        .postStudentOpportunityContact({
          studentOpportunityId: this.studentOpportunityId,
          studentOpportunityContacts: [
            {
              studentOpportunityId: this.studentOpportunityId,
              siteContactId: siteContactId,
              siteContact: studentOpportunityContact
            }
          ]
        })
        .then(function () {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Site supervisor has been set.", "Success");
        })
        .catch(function (error) {
          console.log(error);
        });
      this.show = false;
    },

    updateStudentCourse: function (studentCourse) {
      console.log(studentCourse);

      this.studentOpportunity.subjectCode = studentCourse.subjectCode;
      this.studentOpportunity.catalogNumber = studentCourse.catalogNumber;
      this.studentOpportunity.scheduleLineNumber =
        studentCourse.scheduleLineNumber;

      this.studentOpportunity.unitsMinimum = studentCourse.unitsMinimum;
      this.studentOpportunity.unitsMaximum = studentCourse.unitsMaximum;

      this.studentOpportunity.locationCode = studentCourse.locationCode;
      this.studentOpportunity.location = studentCourse.location;
      this.studentOpportunity.instructionMode = studentCourse.instructionMode;
      this.studentOpportunity.sessionCode = studentCourse.sessionCode;
      this.studentOpportunity.sessionLd = studentCourse.sessionLd;

      studentOpportunityApi
        .postUpdateClass(this.studentOpportunity)
        .then(function () {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The class has been updated", "Success");
        })
        .catch(function (error) {
          console.log(error);
        });
      this.showCourseModal = false;
    },

    updateDates: function (form) {
      console.log(form);

      this.studentOpportunity.startDate = form.startDate;
      this.studentOpportunity.endDate = form.endDate;
      this.studentOpportunity.hoursWorked = form.hoursWorked;

      studentOpportunityApi
        .postUpdateHours(this.studentOpportunity)
        .then(function () {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("The class has been updated", "Success");
        })
        .catch(function (error) {
          console.log(error);
        });
      this.showHoursModal = false;
    }
  },

  created() {
    var that = this;

    this.getStudentOpportunity();

    studentOpportunityApi
      .getAdditionalMaterialStatuses()
      .then(function (response) {
        that.additionalMaterialStatuses = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    studentOpportunityApi
      .getStudentNotes(this.studentOpportunityId)
      .then(function (response) {
        that.notes = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    this.getSiteSupervisorsByStudentOpportunity(this.studentOpportunityId);
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.side-card {
  background-color: #fafafa;
}
</style>
